import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Chip,
  Avatar,
} from "@mui/material";
import { Email, Phone, Person, Subject, Message, CalendarToday } from "@mui/icons-material";

interface Props {
  open: boolean;
  onClose: () => void;
  message: ContactUsMessage;
}

const ContactMessageDetailDialog: React.FC<Props> = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            <Person />
          </Avatar>
          <Typography variant="h6">Message from {message.full_name}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2}>
          {/* Sender Information */}
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1" fontWeight="bold">Sender Information</Typography>
            <Box display="flex" alignItems="center" gap={2}>
              <Email color="action" />
              <Typography>{message.email}</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Phone color="action" />
              <Typography>{message.phone_number}</Typography>
            </Box>
          </Box>

          <Divider />

          {/* Message Details */}
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1" fontWeight="bold">Message Details</Typography>
            <Box display="flex" alignItems="center" gap={2}>
              <Subject color="action" />
              <Chip 
                label={message.subject} 
                color={message.subject === 'other' ? 'default' : 'primary'}
                variant="outlined"
              />
            </Box>
       
          </Box>

          <Divider />

          {/* Message Content */}
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={2}>
              <Message color="action" />
              <Typography variant="subtitle1" fontWeight="bold">Message Content</Typography>
            </Box>
            <Box pl={4}>
              <Typography whiteSpace="pre-line">{message.message}</Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactMessageDetailDialog;